import {
  createScheduledEnrichmentStore,
  type ScheduledEnrichmentState,
} from './create-scheduled-enrichment-store';

/** Re-exported for existing consumers that reference the Meta state shape by name. */
export type ScheduledMetaState = ScheduledEnrichmentState;

/**
 * Persisted store for a single Meta Ads scheduled enrichment session.
 * Uses the shared scheduled-enrichment store factory; the `scheduled-meta-enrichment`
 * localStorage key is unchanged so in-flight sessions survive this refactor.
 */
export const useScheduledMetaStore = createScheduledEnrichmentStore('scheduled-meta-enrichment');
